@if (presentOverlaySg()) {
  <atn-ds-attached-overlay
    [origin]="originSg()"
    [connectedPositions]="[
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top',
      },
    ]"
    [offsetY]="8"
    (backdropClick)="presentOverlaySg.set(false)"
  >
    <div class="atn-space-records-block-coding">
      @for (option of optionItems; track option.value) {
        <div
          class="atn-space-records-block-coding__row"
          (click)="
            presentOverlaySg.set(false); optionSelected.emit(option.value)
          "
        >
          <span class="atn-space-records-block-coding__row-label">{{
            option.label
          }}</span>
          <i
            class="atn-icon atn-angle-right atn-dark atn-space-records-block-coding__row-arrow"
          ></i>
        </div>
      }
    </div>
  </atn-ds-attached-overlay>
}
